import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Inject, Injectable} from '@angular/core';
import {AuthenticationService} from '../../../service/authentication.service';
import {Observable} from 'rxjs';
import {APP_CONFIG} from '../../../misc/inject-tokens';
import {AppConfig} from '../../../model/app-config.model';

@Injectable()
export class LoginGuard {

  constructor(private authService: AuthenticationService,
              private router: Router,
              @Inject(APP_CONFIG) private config: AppConfig) {
  }

  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isAuthenticated()) {
      return true;
    }

    const target = JSON.parse(localStorage.getItem('ucs-auth-provider'));

    if (target) {
      window.location.href = this.config.authenticationUrl + '/authentication/logon?target=' + target;
    } else {
      this.router.navigate(['/landingpage']);
    }
    return false;
  }
}
